import { Scale, FileCheck2, Building } from "lucide-react";
import { COMPLIANCE } from "@/constants/testIds";

export default function ComplianceNotice() {
  return (
    <section
      id="compliance"
      data-testid={COMPLIANCE.section}
      className="bg-white py-20 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="eyebrow">Compliance & Legal Notice</div>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-slate-900">
            A B2B sourcing agency and trade liaison —{" "}
            <span className="font-semibold">nothing more.</span>
          </h2>
          <div className="mt-8 flex items-center gap-6">
            <div className="h-12 w-12 inline-flex items-center justify-center bg-slate-900 text-white rounded-sm">
              <Scale size={20} />
            </div>
            <div className="h-12 w-12 inline-flex items-center justify-center border border-slate-300 text-slate-700 rounded-sm">
              <FileCheck2 size={20} />
            </div>
            <div className="h-12 w-12 inline-flex items-center justify-center border border-slate-300 text-slate-700 rounded-sm">
              <Building size={20} />
            </div>
          </div>
        </div>

        <div className="lg:col-span-8 space-y-6 text-[15px] leading-relaxed text-slate-700">
          <p>
            <span className="font-semibold text-slate-900">
              PS GLOBAL SERIES, LLC
            </span>{" "}
            operates as a B2B sourcing agency and trade liaison. We facilitate
            connections, negotiations, and procurement between US buyers and
            Dominican Republic suppliers across all industries.
          </p>
          <p>
            We act strictly as intermediaries and consultants, and{" "}
            <span className="font-semibold text-slate-900">do not</span>{" "}
            manufacture, take ownership of, store, transport, or directly
            distribute the physical goods traded between our clients and their
            suppliers. PS GLOBAL SERIES, LLC does not take title to inventory
            and does not act as a principal in counterparty transactions.
          </p>
          <p>
            All client engagements are executed under mutual non-disclosure and
            a defined Statement of Work. Supplier introductions, negotiation
            support, and trade-liaison services are{" "}
            <span className="font-semibold text-slate-900">advisory</span> in
            nature and are intended to support independent decision-making by
            the client&apos;s procurement, legal, and operational teams. Final
            commercial decisions remain the sole responsibility of the client.
          </p>
          <p className="text-slate-500 text-sm italic border-l-2 border-[#B45309] pl-4">
            This notice does not constitute legal advice. PS GLOBAL SERIES, LLC
            complies with all applicable federal, state, and local regulations
            governing the provision of business-to-business sourcing,
            intermediation, and consulting services.
          </p>
        </div>
      </div>
    </section>
  );
}
